import type { Ward } from '../models/address/ward.model';

const baseName = (name: string): string => name.normalize('NFC')
    .toLocaleLowerCase('vi')
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/^(?:xã|phường|thị trấn)\s+/, '');

/** Prefer legacy namesakes for new choices, without changing stored records or IDs. */
export const selectWardOptions = (wards: Ward[], preservedWardIds: readonly string[] = []): Ward[] => {
    const legacyNames = new Set(wards
        .filter(ward => ward.districtId && ward.provinceId && baseName(ward.name))
        .map(ward => JSON.stringify([ward.provinceId, baseName(ward.name)])));
    const preserved = new Set(preservedWardIds);
    return wards.filter(ward => ward.districtId || preserved.has(ward.id)
        || !legacyNames.has(JSON.stringify([ward.provinceId, baseName(ward.name)])));
};
